import React, { memo } from 'react'

type ButtonProps = {
  type: 'button' | 'submit'
  size?: 'small' | 'medium' | 'large' | 'xlarge'
  bg?: 'visible' | 'hidden'
  border?: 'none' | ''
  full?: 'full' | 'nonefull'
  label: string
  isLoading?: boolean
  onClick?: () => void
}

const sizesWidth = (size: 'small' | 'medium' | 'large' | 'xlarge') => {
  let button = ''
  switch (size) {
    case 'medium':
      button = 'button__medium'
      break
    case 'small':
      button = 'button__small'
      break
    case 'large':
      button = 'button__large'
      break
    case 'xlarge':
      button = 'button__xlarge'
      break
    default:
      break
  }

  return button
}

const bgswitch = (bg: 'visible' | 'hidden') => {
  let button = ''
  switch (bg) {
    case 'visible':
      button = 'button__visible'
      break
    case 'hidden':
      button = 'button__hidden'
      break
    default:
      break
  }

  return button
}

const fullsWidth = (full: 'full' | 'nonefull') => {
  let button = ''
  switch (full) {
    case 'full':
      button = 'button__full'
      break
    case 'nonefull':
      button = 'button__nonefull'
      break
    default:
      break
  }

  return button
}

export const Button = memo(
  ({
    type = 'button',
    size = 'medium',
    bg = 'visible',
    border = '',
    full = 'nonefull',
    label,
    isLoading,
  }: ButtonProps) => {
    return (
      <button
        type={type}
        disabled={isLoading}
        className={`base_button ${sizesWidth(size)} ${
          border && 'linkbutton__none'
        } ${bgswitch(bg)} ${fullsWidth(full)} transition ${
          bg === 'hidden'
            ? 'hover:text-secondary hover:border-secondary'
            : 'hover:bg-secondary hover:border-secondary'
        } ${isLoading && 'opacity-60 cursor-wait'}
      `}
      >
        {label}
      </button>
    )
  }
)

Button.displayName = 'Button'
